import { render, staticRenderFns } from "./Backdrop.vue?vue&type=template&id=08714905&scoped=true"
import script from "./Backdrop.vue?vue&type=script&lang=js"
export * from "./Backdrop.vue?vue&type=script&lang=js"
import style0 from "./Backdrop.vue?vue&type=style&index=0&id=08714905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08714905",
  null
  
)

export default component.exports